/**
 * Tarayıcı hata kayıtları — "bir hata verdi ama ne yazdığını okumadım" için.
 * Üç kanca: window.onerror, unhandledrejection, console.error. Son 25 kayıt.
 */
const kayitlar: string[] = [];
const ekle = (tur: string, metin: string) => {
  kayitlar.push(`${new Date().toLocaleTimeString('tr-TR')} [${tur}] ${metin.slice(0, 400)}`);
  if (kayitlar.length > 25) kayitlar.shift();
};
let kuruldu = false;
export function hataKancalariniKur(): void {
  if (kuruldu) return;
  kuruldu = true;
  window.addEventListener('error', (e) => ekle('hata', `${e.message} (${e.filename?.split('/').pop() ?? ''}:${e.lineno})`));
  window.addEventListener('unhandledrejection', (e) => ekle('söz', String((e.reason as Error)?.message ?? e.reason)));
  const asil = console.error.bind(console);
  console.error = (...a: unknown[]) => {
    try { ekle('console', a.map((x) => (x instanceof Error ? x.message : typeof x === 'string' ? x : JSON.stringify(x))).join(' ')); } catch { /* yut */ }
    asil(...a);
  };
}
export const sonHatalar = (): string[] => [...kayitlar];
